export default __webpack_public_path__ + "static/media/customer_service.0361d8ec.jpg";